export const environment = {
  production: false,
  MAIN_URL: 'https://qaebsicr.venturapark.com/api/',
//MAIN_URL: 'https://ebsicr.venturapark.com/api/',
  ZONES: {
    GET_ZONES: 'zones',
  },
  HOTELS: {
    GET_HOTELS: 'hotels',
  },
  TRANSPORTATION: {
    GET: 'web/transportations',
  },
  BANKS: {
    PAYPAL: 'payment/paypal',
    PLUGNPAY: 'payment/plugnpay',
    FRONT_DESK: 'payment/frontdesk',
    CONFIRMATION: '{reservationId}/confirmation',
  },
  ADDONS: {
    TRASNPORTATION: {
      LOCATIONS: [
        2, // Cancun
        4, // Riviera Maya
        7, // Ventura Park
        8, // Selvatica
      ],
    },
    ADO: 317,
  },
  BANKS_AVAILABLE: {
    LOCATIONS: {
      2: ['MIT*', 'PAYPAL'], // Cancun
      4: ['MIT*', 'PAYPAL'], // Riviera Maya
      7: ['MIT', 'PAYPAL', 'PLUGNPAY', 'FRONT-DESK'], // Ventura Park
      8: ['MIT', 'PAYPAL', 'MERCADOPAGO'], // Selvatica, 
      0: ['MIT', 'PAYPAL', 'FRONT-DESK'] // Selva Magica
    },
  },
  URL_SELVATICA: 'https://tdc.selvatica.com.mx',
  URL_VENTURA: 'https://www.venturapark.com',
  URL_CANCUN: 'https://dolphinconnectionmx.com/',
  URL_RIVIERA_MAYA: 'https://dolphinconnectionmx.com/',
  URL_SELVA_MAGICA: 'https://www.selvamagica.com.mx/',
  MAX_PAX: 20,
  BOOKING_TRAVEL: {
    LOCATIONS: {
      2: 0, // Cancun
      4: 0, // Riviera Maya
      7: 0, // Ventura Park
      8: 0, // Selvatica
      10: 0, // Selva Magica
    },
  },
  MAIN_PAX: 2,
  TOTAL_MIN_PAYMENT: {
    2: {
      // Cancun
      LINK: {
        USD: 10,
        MXN: 199,
      },
    },
    4: {
      // Riviera Maya
      LINK: {
        USD: 10,
        MXN: 199,
      },
    },
    7: {
      // Ventura Park
      LINK: {
        USD: 10,
        MXN: 199,
      },
    },
    8: {
      // Selvatica
      LINK: {
        USD: 10,
        MXN: 199,
      },
    },
  },
  WIZARD: {
    // 2: {
    //   // Cancun
    // },
    // 4: {
    //   // Riviera Maya
    // },
    // 7: {
    //   // Ventura Park
    // },
    // 8: {
    //   // Selvatica
    // },
    10: {
       // Selva Magica
     HIDE: ['ADDON'],
    },
  },
  PAYPAL_MODE: 'sandbox',
  PAYPAL_SANDBOX_CLIENT_ID:
    'Aa4eaI5fBGlwvRTzzM9M3hzkksni2SGJeO-buvGnG7ywVkmJqZt2xDPWYfa__ipjaKdeCnhJttdWJHHV',
  PAYPAL_SANDBOX_CLIENT_SECRET:
    'EG7ZP66aSWXuq1XxCKAiIvcwkwq9dWfjizh43mnl1PxRYwCMJ1PzrPmoaoTQvQDTbOYApBJfjw1bXzgp',
  PAYPAL_LIVE_CLIENT_ID:
    'ASkZ9kRcxXTWyjASCcdoGo-YXkO3ESUNs680nL5rUinC2tXVnkCXYhatvmrCX38KNR6kLaBIZCVzuBNw',
  PAYPAL_LIVE_CLIENT_SECRET:
    'EImvoA-OoOaQGeAxbUZj_MDG0YaHHXQmoNTNjK-cV7YMhmy0pEvHphnnWuWNY3pB5XzPZsKpO-HgqTP6',
  GTM_ID: '',
  groupFlag: 20,
  firebase: {
    apiKey: "AIzaSyCF1KsY1nycPq1udi2jLXtH3DlUcKCjBUI",
    authDomain: "icaro-qa-ffc61.firebaseapp.com",
    databaseURL: "https://icaro-qa-ffc61-default-rtdb.firebaseio.com",
    projectId: "icaro-qa-ffc61",
    storageBucket: "icaro-qa-ffc61.firebasestorage.app",
    messagingSenderId: "823452971245",
    appId: "1:823452971245:web:cd651d54f4f2c0bc041ce4"
  },
};
